import { get } from "lodash"

import { IAuthState } from "../models/types";
import * as actionTypes from "../actionsTypes";
import ApiClient, { parseRequestData } from "../utilities/http";
import { Endpoints } from "../utilities/endpoints";
import cookie from "../utilities/cookie";
import { Constants } from "../utilities/constants";
import { toastError, toastSuccess } from "./formInputAction";
import { endCheckingLoginStatus, endSubmitting, isCheckingLoginStatus, isSubmitting } from "./loadActions";
import config from "../utilities/Config";
import { Utility } from "../utilities/utility";
import AuthService from "../services/AuthService";
import { AxiosResponse } from "axios";


export const receiveAuthData = (authData: IAuthState) => ({
    type: actionTypes.LOG_IN,
    payload: { ...authData },
});

//TODO Erik: refactor email to username or similar

function handleLoginSuccess(dispatch: any, response: AxiosResponse, platform: string) {
    const authData: IAuthState = {
        currentUser: undefined,
        isAuthenticated: false,
        passwordChangeRequired: false,
        authErrorCode: undefined,
    };
    const code = get(response, 'data.token');

    if ((get(response, 'statusText') === 'OK') || (get(response, 'status') === 200)) {
        //not all webservers (apparently) send an OK statusText. nginx does not
        cookie.remove(Constants.AUTH_ERROR_CODE_COOKIE);
        cookie.remove(Constants.PENDING_LOGIN_COOKIE);
        cookie.remove(Constants.PENDING_PLATFORM_COOKIE);
        authData.isAuthenticated = true;
        if (code) {
            authData.currentUser = get(response, 'data.user');
            cookie.put('permissible', get(response, 'data.permissible'))
            cookie.put(Constants.ACCESS_KEY, code, "Lax", true);
            cookie.put(Constants.REFRESH_KEY, code, "Lax", true);
            console.log('authData:', authData);
            cookie.put('last_platform', platform);
            cookie.put('current_user', JSON.stringify(authData.currentUser), "Lax", true);
        } else {
            authData.currentUser = AuthService.getUser()
        }
        dispatch(receiveAuthData(authData));
        dispatch(endSubmitting({
            submitButton: false,
        }));
        window.location.replace(config.url + 'dashboard')
    }
}

export function loginNFC(cardSerial: string, platform: string) {
    return (dispatch: any) => {
        dispatch(isSubmitting({
            submitButton: true,
        }));

        ApiClient.post(Endpoints.LOG_IN_NFC as string, parseRequestData({
            card: cardSerial,
            tenant: platform
        })).then((response) => {
            dispatch(endSubmitting({
                submitButton: false,
            }));
            handleLoginSuccess(dispatch, response, platform);
        })
            .catch(err => {
                const apiCode = get(err, 'response.data.code');
                if (apiCode === Constants.PASSWORD_CHANGE_REQUIRED) {
                    cookie.put(Constants.AUTH_ERROR_CODE_COOKIE, Constants.PASSWORD_CHANGE_REQUIRED, "Lax", true);
                    cookie.put(Constants.PENDING_PLATFORM_COOKIE, platform, "Lax", true);
                    dispatch(receiveAuthData({
                        currentUser: undefined,
                        isAuthenticated: false,
                        passwordChangeRequired: true,
                        authErrorCode: Constants.PASSWORD_CHANGE_REQUIRED as string,
                    }));
                    dispatch(endSubmitting({
                        submitButton: false,
                    }));
                    dispatch(toastError({}, 'Password change required'));
                    window.location.replace(config.url + 'password-change-required');
                    return;
                }

                let msg: string = 'An error occurred';
                if (err.response?.status === 401) {
                    msg = 'Error logging in with your card';
                }
                if (err.response?.data !== undefined) {
                    msg = err.response.data?.error;
                }
                console.error(msg);
                dispatch(toastError(err, 'Login error'));
            })
    }
}

export const loginIn = (email: string, password: string, platform: string) => {
    // console.log('authActions: config', config);
    return (dispatch: any) => {
        dispatch(isSubmitting({
            submitButton: true,
        }));
        ApiClient.post(Endpoints.LOG_IN as string, parseRequestData(
            {
                login: email,
                password: password,
                tenant: platform,
                clientIdentifier: config.clientIdentifier
            })).then((response) => {
                dispatch(endSubmitting({
                    submitButton: false,
                }));
                const authData: IAuthState = {
                    currentUser: undefined,
                    isAuthenticated: false,
                    passwordChangeRequired: false,
                    authErrorCode: undefined,
                };
                const code = get(response, 'data.token');


                if ((get(response, 'statusText') === 'OK') || (get(response, 'status') === 200)) {
                    //not all webservers (apparently) send an OK statusText. nginx does not
                    cookie.remove(Constants.AUTH_ERROR_CODE_COOKIE);
                    cookie.remove(Constants.PENDING_LOGIN_COOKIE);
                    cookie.remove(Constants.PENDING_PLATFORM_COOKIE);
                    authData.isAuthenticated = true;
                    if (code) {
                        authData.currentUser = get(response, 'data.user');
                        cookie.put('permissible', get(response, 'data.permissible'))
                        cookie.put(Constants.ACCESS_KEY, code, "Lax", true);
                        cookie.put(Constants.REFRESH_KEY, code, "Lax", true);
                        // console.log('authData:', authData);
                        cookie.put('last_platform', platform);
                        cookie.put('current_user', JSON.stringify(authData.currentUser), "Lax", true);
                    } else {
                        authData.currentUser = AuthService.getUser()
                    }
                    const publicVapid = get(response, 'data.public_vapid');
                    if (publicVapid) {
                        cookie.put(Constants.VAPID_PUBLIC_KEY, publicVapid);
                        dispatch({
                            type: actionTypes.USE_PUSH_MESSAGES,
                            payload: {
                                uses_push: true
                            }
                        });
                    } else {
                        cookie.remove(Constants.VAPID_PUBLIC_KEY);
                        dispatch({
                            type: actionTypes.USE_PUSH_MESSAGES,
                            payload: {
                                uses_push: false
                            }
                        });

                    }
                    dispatch(receiveAuthData(authData));
                    dispatch(endSubmitting({
                        submitButton: false,
                    }));
                    // console.log('authActions: config2', config);
                    let dashboard = config.url + 'dashboard';
                    window.location.replace(dashboard);
                    // window.location.replace(config.url + 'dashboard')
                } else {
                    dispatch(toastError({}, 'Error Logging In'))
                }
                dispatch(receiveAuthData(authData));
            }).catch(err => {
                const apiCode = get(err, 'response.data.code');

                if (apiCode === Constants.PASSWORD_CHANGE_REQUIRED) {
                    cookie.put(Constants.AUTH_ERROR_CODE_COOKIE, Constants.PASSWORD_CHANGE_REQUIRED, "Lax", true);
                    cookie.put(Constants.PENDING_LOGIN_COOKIE, email, "Lax", true);
                    cookie.put(Constants.PENDING_PLATFORM_COOKIE, platform, "Lax", true);
                    dispatch(receiveAuthData({
                        currentUser: undefined,
                        isAuthenticated: false,
                        passwordChangeRequired: true,
                        authErrorCode: Constants.PASSWORD_CHANGE_REQUIRED as string,
                    }));
                    dispatch(endSubmitting({
                        submitButton: false,
                    }));
                    dispatch(toastError({}, "Password change required"));
                    window.location.replace(config.url + 'password-change-required');
                    return;
                }

                cookie.remove(Constants.AUTH_ERROR_CODE_COOKIE);
                dispatch(toastError(
                    err, "Login Error"
                ));

                dispatch(endSubmitting({
                    submitButton: false,
                }));

                dispatch(receiveAuthData({
                    currentUser: undefined,
                    isAuthenticated: false,
                    passwordChangeRequired: false,
                    authErrorCode: undefined,
                }))
            });
    }
};

export const checkLogin = () => {
    return (dispatch: any) => {
        dispatch(isCheckingLoginStatus({
            appComponent: true,
        }));
        ApiClient.put(Endpoints.USER_STATUS_HEART_BEAT as string, parseRequestData({ status: 'online' })).then((response) => {
            cookie.remove(Constants.AUTH_ERROR_CODE_COOKIE);
            dispatch(endCheckingLoginStatus({
                appComponent: false,
            }));
            dispatch(receiveAuthData({
                currentUser: JSON.parse(cookie.get('current_user')),
                isAuthenticated: true,
                passwordChangeRequired: false,
                authErrorCode: undefined,
            }))
        }).catch(err => {
            dispatch(endCheckingLoginStatus({
                appComponent: false,
            }));
            dispatch(receiveAuthData({
                currentUser: undefined,
                isAuthenticated: false,
                passwordChangeRequired: cookie.get(Constants.AUTH_ERROR_CODE_COOKIE) === Constants.PASSWORD_CHANGE_REQUIRED,
                authErrorCode: cookie.get(Constants.AUTH_ERROR_CODE_COOKIE),
            }))
        });
    }
}

export const logout = () => {
    return (dispatch: any) => {
        const authData: IAuthState = {
            currentUser: undefined,
            isAuthenticated: false
        };
        dispatch(receiveAuthData(authData));

        ApiClient.post(Endpoints.LOG_OUT as string).then((response) => {
            toastSuccess('Successful', "Logged out successfully")
        }).catch(err => {
            // toastError(err, "Error login out")
        }).finally(() => {
            Utility.clearLoginCookies();
            // Notify the Service Worker
            if (navigator.serviceWorker?.controller) {
                navigator.serviceWorker.controller.postMessage({
                    type: 'LOGOUT'
                });
            }
            Utility.redirectToLogin();
        })
    }
};

export const changeRequiredPassword = (login: string, platform: string, currentPassword: string, password: string, passwordConfirmation: string) => {
    return (dispatch: any) => {
        dispatch(isSubmitting({
            submitButton: true,
        }));

        ApiClient.post(Endpoints.PASSWORD_CHANGE_REQUIRED as string, parseRequestData({
            login,
            tenant: platform,
            current_password: currentPassword,
            password,
            password_confirmation: passwordConfirmation,
        })).then(() => {
            cookie.remove(Constants.AUTH_ERROR_CODE_COOKIE);
            cookie.remove(Constants.PENDING_LOGIN_COOKIE);
            cookie.remove(Constants.PENDING_PLATFORM_COOKIE);
            dispatch(endSubmitting({
                submitButton: false,
            }));
            dispatch(toastSuccess('Success', 'Password changed successfully'));
            window.location.replace(config.url + 'login');
        }).catch((err) => {
            dispatch(endSubmitting({
                submitButton: false,
            }));
            dispatch(toastError(err, 'Password change failed'));
        });
    };
}

export const getLogoURL = () => {
    return (dispatch: any) => {
        ApiClient.get(Endpoints.LOGO_URL as string).then((response) => {
            const logoUrl = get(response, 'data.logo_url');
            dispatch({
                type: actionTypes.RECEIVE_LOGO_URL,
                payload: { logoURL: logoUrl }
            })
        })
    }
}

export const getBackgroundURL = () => {
    return (dispatch: any) => {
        ApiClient.get(Endpoints.BACKGROUND_URL as string).then((response) => {
            const backgroundUrl = get(response, 'data.background_url');
            dispatch({
                type: actionTypes.RECEIVE_BACKGROUND_URL,
                payload: { backgroundURL: backgroundUrl }
            })
        })
    }
}
